import { render, staticRenderFns } from "./SEOptimize.vue?vue&type=template&id=afe2ef70"
import script from "./SEOptimize.vue?vue&type=script&lang=js"
export * from "./SEOptimize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports